<script setup lang="ts">
import { computed, onMounted, watch } from 'vue';
import Notes from './components/Notes.vue';
import General from './components/General.vue';
import Services from './components/Services.vue';
import MedicaidTable from './components/MedicaidTable.vue';
import { PersonStores } from '@/store';
import { can, useTenant } from '@/composables';
import { PERMISSIONS, TENANT_SETTINGS } from '@/enum';
import { storeToRefs } from 'pinia';

const treatmentPlansStore = PersonStores.useUserTreatmentPlansStore();
const profileStore = PersonStores.useUserProfileStore();
const hasError = computed(() => !!treatmentPlansStore.error);
const { id } = storeToRefs(profileStore);
const $tenant = useTenant();
const medicaidEnabled = computed(() => $tenant.tenantSettingEnabled(TENANT_SETTINGS.MEDICAID_BILLING));

const canViewTreatmentPlanAndPlanExists = computed(() => {
  return can([PERMISSIONS.PERSON_TREATMENT_PLANS_INDEX_STUDENTS]) && !!treatmentPlansStore.planId;
});

const init = async () => {
  treatmentPlansStore.showExpired = false;
  if (profileStore.id != treatmentPlansStore.userTreatmentPlans?.person_id) {
    treatmentPlansStore.userTreatmentPlans = undefined;
    treatmentPlansStore.treatmentPlanCategories = undefined;
  }

  if (profileStore.id && can([PERMISSIONS.PERSON_TREATMENT_PLANS_INDEX_STUDENTS])) {
    await treatmentPlansStore.getUserTreatmentPlans(profileStore.id);
    await treatmentPlansStore.fetchAllTreatmentPlanFormData();
  }

  if (hasError.value) {
    treatmentPlansStore.doToast(treatmentPlansStore.error as string, 'Error', true);
  }
};

watch(id, init);

onMounted(() => init());
</script>

<template>
  <General />
  <MedicaidTable
    v-if="canViewTreatmentPlanAndPlanExists && medicaidEnabled"
    :key="treatmentPlansStore.planId"
    @update="init"
  />
  <Services v-if="canViewTreatmentPlanAndPlanExists" :key="treatmentPlansStore.planId" />
  <Notes v-if="canViewTreatmentPlanAndPlanExists" :key="treatmentPlansStore.planId" />
</template>
